var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"border-top p-0"},[_c('b-navbar-nav',[_c('b-nav-text',[_c('h2',{staticClass:"title marker"},[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }